const dateFormat = 'D/M/YYYY'
const timeFormat = 'h:mm a'

const distributionTypeLabelMap = {
  'All': 'contentMonitor.channelList.distributionType.all',
  'Tour Operator': 'contentMonitor.channelList.distributionType.tourOperator',
  'OTA': 'contentMonitor.channelList.distributionType.ota',
  'IT & CRS': 'contentMonitor.channelList.distributionType.itCrs',
  'Bed Bank & GDS': 'contentMonitor.channelList.distributionType.bedBank',
  'Metasearch': 'contentMonitor.channelList.distributionType.metasearch',
  'Travel Agency': 'contentMonitor.channelList.distributionType.travelAgency',
  'AI Platform': 'contentMonitor.channelList.distributionType.aiPlatform'
}

export const updateCycleTooltipMap = {
  'On request': 'contentMonitor.channelList.body.updateCycle.onRequest.tooltip',
}

export const imageConsumptionLabelMap = {
  'Activation Necessary': {
    code: 'AN',
    titleKey: 'contentMonitor.channelList.body.imageConsumption.imageConsumptionLabels.AN.title',
    descriptionKey: 'contentMonitor.channelList.body.imageConsumption.imageConsumptionLabels.AN.description',
  },
  'On Request': {
    code: 'OR',
    titleKey: 'contentMonitor.channelList.body.imageConsumption.imageConsumptionLabels.OR.title',
    descriptionKey: 'contentMonitor.channelList.body.imageConsumption.imageConsumptionLabels.OR.description',
  },
  'Single Source': {
    code: 'SG',
    titleKey: 'contentMonitor.channelList.body.imageConsumption.imageConsumptionLabels.SG.title',
    descriptionKey: 'contentMonitor.channelList.body.imageConsumption.imageConsumptionLabels.SG.description',
  },
  'Mixed Source': {
    code: 'MX',
    titleKey: 'contentMonitor.channelList.body.imageConsumption.imageConsumptionLabels.MX.title',
    descriptionKey: 'contentMonitor.channelList.body.imageConsumption.imageConsumptionLabels.MX.description',
  },
  'Partial Use': {
    code: 'PU',
    titleKey: 'contentMonitor.channelList.body.imageConsumption.imageConsumptionLabels.PU.title',
    descriptionKey: 'contentMonitor.channelList.body.imageConsumption.imageConsumptionLabels.PU.description',
  },
}

export { dateFormat, timeFormat, distributionTypeLabelMap }
